/**
 * Every route URL in one place. Components link through `paths`,
 * never through hand-written strings, so a URL change is a one-line change.
 */
export const paths = {
  root: '/',
  auth: {
    login: '/login',
  },
  projects: {
    pipeline: '/pipeline',
    new: '/requests/new',
    detail: (id: string) => `/requests/${id}`,
  },
  people: {
    roster: '/people',
    detail: (id: string) => `/people/${id}`,
  },
  admin: {
    users: '/admin/users',
  },
  notFound: '*',
} as const
